import { Component, OnInit } from '@angular/core';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { RewardsService } from 'src/app/services/rewards/rewards.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";

@Component({
  selector: 'app-starcard-convert',
  templateUrl: './starcard-convert.page.html',
  styleUrls: ['./starcard-convert.page.scss'],
})
export class StarcardConvertPage implements OnInit {

  isLoading: boolean = false;
  selectedOption;
  convertionRate = [];
  points = 0;
  minimumPoints = 1;
  isShowError: boolean = false;
  errorMessage = "Your points conversion was not successful";
  errorMessage2 = "Please try again later.";
  successMessage = "";
  buttonText = "Go to lobby";
  private numberOfPoints: number = 0;
  public confirmationMsg = "Do you want to continue with the conversion?";
  public confirmationMsg2 = "";
  public convert_States = {
    currentStatus: 'CURRENT_STATUS_WINDOW',
    requestConfirm: 'REQUEST_CONFIRM_WINDOW',
    feedBack: 'FEEDBACK_WINDOW'
  }
  private cashValue = 0;
  private selectedBucket
  public currentState = this.convert_States.currentStatus;
  public infoLink = "";
  constructor(private rewardsBService: BoydRewardsService,
    private rewardsService: RewardsService,
    public webcontentService: WebcontentService,
    public navigator: Navigator,
    private config:ConfigService
  ) { }

  ngOnInit() {
    this.initAllData();
    this.setConfigValues();
  }

  public gotoInfoPage(){
    this.navigator.dismiss();
    this.webcontentService.updateExternalLink(this.infoLink);
    this.navigator.toWebview(false, this.infoLink);
  }
  
  private setConfigValues() {
    const config = this.config.getConfig();
    this.infoLink = config.RESORTS_CARD_PROGRAM_URL ?? "https://www.resortscasino.com";
  }

  initAllData() {
    this.isLoading = true;
    this.rewardsBService.getExtConversionRate().subscribe(
      (response) => {
        this.convertionRate = (response.result == 1 && response.payload) ? Object.keys(response.payload).map(key => ({
          bucket: key,
          displayName: this.getBucketDisplayName(key),
          rate: response.payload[key].toString() // convert the value to a string
        })) : [];
        this.stopLoader();
      },
      (error) => {
        this.stopLoader();
      }
    );
  }

  pointsChange(points) {
    this.numberOfPoints = points;
  }

  redeemClicked(redeemObj) {
    this.cashValue = redeemObj?.cashValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) || '0.00';
    this.points = this.numberOfPoints;
    this.selectedBucket = redeemObj?.bucket;
    this.currentState = this.convert_States.requestConfirm;
    this.confirmationMsg2 = `Convert ${this.points} Points to $${this.cashValue} in ${this.getBucketDisplayName(redeemObj?.bucket)} on my Star Card`;
  }

  private getBucketDisplayName(bucket) {
    return bucket == "slot" ? "Slot Cash" : "Comp Dollars";
  }

  clickCancel() {
    this.currentState = this.convert_States.currentStatus;
  }

  clickContinue() {
    this.isLoading = true
    this.rewardsService.convertExternalPoints(this.points, this.selectedBucket).subscribe((res) => {
      console.log("bucket ", res)
      this.rewardsService.removeLoyaltyPoints();
      this.stopLoader();
      this.isShowError = false;
      this.buttonText = "Go to lobby";
      this.successMessage = `You have successfully converted ${this.points} points to $${this.cashValue} in ${this.getBucketDisplayName(this.selectedBucket)} on Your Star Card`;
      this.currentState = this.convert_States.feedBack;
    }, (error) => {
      this.stopLoader();
      this.buttonText = "Try Again";
      this.isShowError = true;
      this.currentState = this.convert_States.feedBack;
    })
  }

  clickCurrentStatus() {
    if (this.isShowError) {
      this.rewardsService.removeLoyaltyPoints();
      this.currentState = this.convert_States.currentStatus;
      return;
    }
    this.navigator.dismissAll();
  }

  onClickClose() {
    this.navigator.back();
  }

  onBack = () => {
    if (this.currentState == this.convert_States.requestConfirm || this.isShowError) {
      this.currentState = this.convert_States.currentStatus;
    } else {
      this.navigator.back();
    }
  }

  private stopLoader() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

}
